import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.625 2.25a.37.37 0 0 0-.375.375V4.5h7.5V2.625a.4.4 0 0 0-.375-.375zM6 2.625C6 1.219 7.172 0 8.625 0h6.75C16.781 0 18 1.219 18 2.625V4.5h3c1.64 0 3 1.36 3 3v12c0 1.688-1.36 3-3 3H3c-1.687 0-3-1.312-3-3v-12c0-1.64 1.313-3 3-3h3zm4.5 7.125V12H8.25c-.422 0-.75.375-.75.75v1.5c0 .422.328.75.75.75h2.25v2.25c0 .422.328.75.75.75h1.5c.375 0 .75-.328.75-.75V15h2.25c.375 0 .75-.328.75-.75v-1.5c0-.375-.375-.75-.75-.75H13.5V9.75c0-.375-.375-.75-.75-.75h-1.5c-.422 0-.75.375-.75.75"
    }, null, -1)
  ]))]))
}
export default { render: render }